import { FilterComparisonOperator } from '@/common/models';
import i18n from '@/vueI18n';

export default class NumericFilterComparisonOptions {
  static get Equals() {
    return {
      id: 'eq',
      label: '=',
      operators: [FilterComparisonOperator.EQUAL],
    };
  }

  static get NotEquals() {
    return {
      id: 'ne',
      label: '!=',
      operators: [FilterComparisonOperator.NOT_EQUAL],
    };
  }

  static get GreaterThan() {
    return {
      id: 'gt',
      label: '>',
      operators: [FilterComparisonOperator.GREATER_THAN],
    };
  }

  static get GreaterThanOrEqual() {
    return {
      id: 'gte',
      label: '>=',
      operators: [FilterComparisonOperator.GREATER_THAN_OR_EQUAL],
    };
  }

  static get LessThan() {
    return {
      id: 'lt',
      label: '<',
      operators: [FilterComparisonOperator.LESS_THAN],
    };
  }

  static get LessThanOrEqual() {
    return {
      id: 'lte',
      label: '<=',
      operators: [FilterComparisonOperator.LESS_THAN_OR_EQUAL],
    };
  }

  static get Between() {
    return {
      id: 'between',
      label: i18n.global.t('messages.inRange'),
      operators: [FilterComparisonOperator.GREATER_THAN_OR_EQUAL, FilterComparisonOperator.LESS_THAN_OR_EQUAL],
    };
  }

  static get IsEmpty() {
    return {
      id: 'is-empty',
      label: i18n.global.t('messages.isEmpty'),
      operators: [FilterComparisonOperator.EQUAL],
    };
  }

  static get all() {
    return [
      NumericFilterComparisonOptions.Equals,
      NumericFilterComparisonOptions.NotEquals,
      NumericFilterComparisonOptions.GreaterThan,
      NumericFilterComparisonOptions.GreaterThanOrEqual,
      NumericFilterComparisonOptions.LessThan,
      NumericFilterComparisonOptions.LessThanOrEqual,
      NumericFilterComparisonOptions.Between,
      NumericFilterComparisonOptions.IsEmpty,
    ];
  }
}
